import { cn } from "../../../lib/cn";

/**
 * KanbanCard — tarjeta del kanban.
 *
 * Borde izquierdo 4px en color de prioridad. Sin prioridad (null/undefined,
 * p.ej. incidencia recién creada o sugerencia) → borde neutro sutil, NUNCA
 * el color de "media" (sería engañoso).
 * Borde superior 3px opcional (aging warning):
 *   - "warning" (naranja): >3 días sin actualizar
 *   - "danger" (rojo): >7 días sin actualizar
 */

const PRIORITY_BORDER = {
  baja:    "border-l-slate-300",
  media:   "border-l-blue-500",
  alta:    "border-l-red-500",
  critica: "border-l-red-700",
};
// Fallback para prioridad ausente: neutro, casi invisible pero no confuso.
const SIN_PRIORIDAD_BORDER = "border-l-slate-200";

const AGING_BORDER = {
  none:    "",
  warning: "border-t-[3px] border-t-orange-400",
  danger:  "border-t-[3px] border-t-red-500",
};

export function KanbanCard({
  priority = null,
  aging = "none",
  id,
  title,
  meta,
  onClick,
  className,
}) {
  return (
    <div
      onClick={onClick}
      className={cn(
        "bg-card border border-border rounded-lg p-3 cursor-pointer",
        "hover:shadow-sm transition-shadow",
        "border-l-[4px]",
        PRIORITY_BORDER[priority] ?? SIN_PRIORIDAD_BORDER,
        AGING_BORDER[aging],
        className,
      )}
    >
      {id && (
        <div className="font-mono text-[11px] text-slate-400 mb-1">{id}</div>
      )}
      <div className="text-sm font-semibold text-slate-900 mb-2 line-clamp-2">
        {title}
      </div>
      {meta && (
        <div className="text-xs text-slate-500 flex items-center gap-2">
          {meta}
        </div>
      )}
    </div>
  );
}
